/**
 * @Author: wuyang
 * @Date: 2024/1/25
 * @Description: ""
 */
import internal from 'stream'
import { ITask, ITaskResultImage, ITaskSeg, ITaskCropping } from '@/types/task'

// 0-切割时的推送  1-任务排队或执行中的推送  2-关注后推送  3-支付成功后的推送 4-4k 图成功的推送 heart 心跳检测 6-裁剪推送
export enum ESocketPushType {
	'seg' = 0,
	'taskStatus' = 1,
	'wxFollow' = 2,
	'payStatus' = 3,
	'k4Image' = 4 ,
	'crop' = 6
}

// 切割时推送的结果
export interface ISocketMessageSeg
	extends Pick<ITask, 'status' | 'taskId' | 'type' | 'userId'> {
	seg_data: ITaskSeg
}

// 裁剪推送结果
export interface ISocketMessageCropping
	extends Pick<ITask,'status' | 'taskId' | 'type' | 'userId'> {
	croppingData: ITaskCropping
}

// 任务排队的推送结果
export interface ISocketMessageTaskStatus
	extends Pick<
		ITask,
		'status' | 'taskId' | 'type' | 'userId' | 'taskOrdinalId'
	> {
	ordinalImgResultList: ITaskResultImage[]
	del_flag: number
}

// 4k 图生成图的进度
export interface ISocketMessage4KPush
	extends Pick<
		ITask,
		'status' | 'taskId' | 'type' | 'userId' | 'taskOrdinalId'
	> {
	// ITaskResultImage.resImgUrl 4k 图的 URL 地址
	ordinalImgResultList: [ITaskResultImage]
}

export interface ISocketMessagePayStatus {
	msg: string
	orderNo: string
	// 1 支付成功， 0 支付失败
	status: 1 | 0
	// 0 算力包， 1 升级套餐
	type: 1 | 0
	userId: number
}

export interface ISocketMessageHeart {
	heart: string
}

// 不同任务对应的不同数据
export interface ISocketDataByType {
	[ESocketPushType.seg]: ISocketMessageSeg
	[ESocketPushType.taskStatus]: ISocketMessageTaskStatus
	[ESocketPushType.wxFollow]: {}
	[ESocketPushType.payStatus]: ISocketMessagePayStatus
	[ESocketPushType.k4Image]: ISocketMessage4KPush
	[ESocketPushType.crop]: ISocketMessageCropping
}

// 通用 socket 推送协议
export interface ISocketMessage {
	message: ISocketDataByType[ESocketPushType]
	pushType: ESocketPushType
	userId: string
}
